<ion-item>
  <ion-input
    label="Sport Name"
    labelPlacement="floating"
    placeholder="Sport Name"
    [(ngModel)]="sportName"
    type="text"
    autocapitalize="words"
  ></ion-input>
</ion-item>

<ion-item>
  <ion-textarea
    label="Description"
    labelPlacement="floating"
    placeholder="Description"
    [(ngModel)]="description"
    autocapitalize="sentences"
  ></ion-textarea>
</ion-item>

<div class="px py">
  <app-select-muscle-group
    [hashtags]="hashtags"
    [toggleStates]="toggleStates"
    [title]="'Primary muscles'"
  >
  </app-select-muscle-group>
</div>

<div class="px py">
  <app-select-muscle-group
    [hashtags]="secondaryHashtags"
    [toggleStates]="secondaryToggleStates"
    [title]="'Secondary muscles'"
  >
  </app-select-muscle-group>
</div>

<ion-item lines="none" (click)="openGifRecorderModal($event)">
  <div class="image-upload-wrapper">
    <img
      [src]="imagePreview"
      *ngIf="imagePreview; else noImage"
      class="image-preview"
    />
    <ng-template #noImage>
      <div class="no-image-content">
        <ion-icon name="camera" class="no-image-icon"></ion-icon>
        <p class="capture-text">Tap to capture</p>
      </div>
    </ng-template>
    <ion-icon
      name="close-circle"
      class="delete-icon"
      *ngIf="imagePreview"
      (click)="deleteImage($event)"
    ></ion-icon>
  </div>
</ion-item>

<ion-button fill="outline" class="py px" expand="block" (click)="openFileInput()">
  <ion-icon name="folder-open" slot="start"></ion-icon>
  Add from files
</ion-button>

<ion-button fill="outline" class="py px" expand="block" id="open-gif-modal">
  <ion-icon name="images" slot="start"></ion-icon>
  Select gif
</ion-button>

<input
  type="file"
  accept="image/*"
  (change)="onFileSelected($event)"
  #fileInput
  style="display: none;"
/>

<ion-modal #modal2 trigger="open-gif-modal" [presentingElement]="presentingElement">
  <ng-template>
    <ion-content>
      <app-gif-search [searchValue]="sportName" (gifSelected)="addGifFromUrl($event)"></app-gif-search>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-modal #gifRecorderModal>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>Record GIF</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="gifRecorderModal.dismiss()">Close</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <app-gif-recorder (recordingComplete)="onGifRecordingComplete($event)"></app-gif-recorder>
    </ion-content>
  </ng-template>
</ion-modal>

<ion-button class="py px" [disabled]="!sportName || loading" expand="block" (click)="emitExercise()">
  <ion-spinner slot="start" *ngIf="loading"></ion-spinner>
  {{confirmText}}
</ion-button>
